<template>
  <v-data-table
    :headers="headers"
    :items="datas"
    mobile-breakpoint="0"
    class="table-education"
  >
    <template v-slot:item="row">
      <tr class="tr-stretch">
        <td>
          <v-icon
            small
            class="mr-2"
            @click="editItem(row.item)"
            style="color: #00a4b3"
          >
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(row.item)" style="color: #00a4b3">
            mdi-delete
          </v-icon>
        </td>
        <td class="text-custom tb-wide uppercase-table">
          {{ row.item.university }}
        </td>
        <td class="text-custom tb-wide uppercase-table">{{ row.item.city }}</td>
        <td class="text-custom uppercase-table">{{ row.item.state }}</td>
        <td class="text-custom">{{ row.item.country }}</td>
        <td class="text-custom">{{ row.item.major }}</td>
      </tr>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{
          $t("page.profile.eduction_info")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#00A4B3" dark class="mb-2" v-bind="attrs" v-on="on">
              {{ $t("add") }}
            </v-btn>
          </template>
          <v-card>
            <v-form ref="form" lazy-validation>
              <v-card-title>{{
                $t("page.profile.add_new_education")
              }}</v-card-title>
              <v-divider class="mt-1"></v-divider>
              <v-card-text>
                <v-text-field
                  v-model="university"
                  class="uppercase-input"
                  :rules="[v => !!v || $t('this_field_required')]"
                  :label="$t('page.profile.univ_name')"
                  :placeholder="$t('page.profile.univ_name')"
                ></v-text-field>
                <v-text-field
                  v-model="city"
                  class="uppercase-input"
                  :rules="[v => !!v || $t('this_field_required')]"
                  :label="$t('field.city')"
                  :placeholder="$t('field.city')"
                ></v-text-field>
                <v-text-field
                  v-model="state"
                  class="uppercase-input"
                  :rules="[v => !!v || $t('this_field_required')]"
                  :label="$t('field.state')"
                  :placeholder="$t('field.state')"
                ></v-text-field>
                <v-autocomplete
                  v-model="country"
                  :rules="[v => !!v || $t('this_field_required')]"
                  :items="countries"
                  :label="$t('field.country')"
                  :placeholder="$t('field.country')"
                ></v-autocomplete>
                <v-text-field
                  v-model="major"
                  :rules="[v => !!v || $t('this_field_required')]"
                  :label="$t('page.profile.major')"
                  :placeholder="$t('page.profile.major')"
                ></v-text-field>
              </v-card-text>
              <v-divider class="mt-1"></v-divider>
              <v-card-actions class="justify-end">
                <v-btn text @click="close"> {{ $t("cancel") }} </v-btn>
                <v-btn color="#00a4b3" text @click="save">
                  {{ $t("save") }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEdit" max-width="500px">
          <v-card>
            <v-form ref="form" lazy-validation>
              <v-card-title>{{
                $t("page.profile.edit_education")
              }}</v-card-title>
              <v-divider class="mt-1"></v-divider>
              <v-card-text>
                <v-text-field
                  v-model="editedItem.university"
                  class="uppercase-input"
                  :rules="[
                    () => !!editedItem.university || $t('this_field_required'),
                  ]"
                  :label="$t('page.profile.univ_name')"
                  :placeholder="$t('page.profile.univ_name')"
                ></v-text-field>
                <v-text-field
                  v-model="editedItem.city"
                  class="uppercase-input"
                  :rules="[
                    () => !!editedItem.city || $t('this_field_required'),
                  ]"
                  :label="$t('field.city')"
                  :placeholder="$t('field.city')"
                ></v-text-field>
                <v-text-field
                  v-model="editedItem.state"
                  class="uppercase-input"
                  :rules="[
                    () => !!editedItem.state || $t('this_field_required'),
                  ]"
                  :label="$t('field.state')"
                  :placeholder="$t('field.state')"
                ></v-text-field>
                <v-text-field
                  v-model="editedItem.country"
                  :rules="[
                    () => !!editedItem.country || $t('this_field_required'),
                  ]"
                  :label="$t('field.country')"
                  :placeholder="$t('field.country')"
                ></v-text-field>
                <v-text-field
                  v-model="editedItem.major"
                  :rules="[
                    () => !!editedItem.major || $t('this_field_required'),
                  ]"
                  :label="$t('page.profile.major')"
                  :placeholder="$t('page.profile.major')"
                ></v-text-field>
              </v-card-text>
              <v-divider class="mt-1"></v-divider>
              <v-card-actions class="justify-end">
                <v-btn text @click="closeEdit"> {{ $t("cancel") }} </v-btn>
                <v-btn color="#00a4b3" text @click="update">
                  {{ $t("update") }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" max-width="290">
          <v-card>
            <v-card-title class="text-h5">
              {{ $t("confirmation_dialog") }}
            </v-card-title>
            <v-card-text>
              {{ $t("page.profile.u_sure_want_delete") }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeDelete">{{ $t("cancel") }}</v-btn>
              <v-btn color="#00a4b3" text @click="deleteItemConfirm">{{
                $t("oke")
              }}</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
      <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import Auth from "@/service/auth_service";
import API from "@/service/api_service";
export default {
  data: () => ({
    dialog: false,
    dialogDelete: false,
    dialogEdit: false,
    formHasError: false,
    headers: [],
    datas: [],
    countries: [
      "Afghanistan",
      "Albania",
      "Algeria",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antigua &amp; Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia &amp; Herzegovina",
      "Botswana",
      "Brazil",
      "British Virgin Islands",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Cape Verde",
      "Cayman Islands",
      "Chad",
      "Chile",
      "China",
      "Colombia",
      "Congo",
      "Cook Islands",
      "Costa Rica",
      "Cote D Ivoire",
      "Croatia",
      "Cruise Ship",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Estonia",
      "Ethiopia",
      "Falkland Islands",
      "Faroe Islands",
      "Fiji",
      "Finland",
      "France",
      "French Polynesia",
      "French West Indies",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea Bissau",
      "Guyana",
      "Haiti",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kuwait",
      "Kyrgyz Republic",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macau",
      "Macedonia",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Mauritania",
      "Mauritius",
      "Mexico",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Namibia",
      "Nepal",
      "Netherlands",
      "Netherlands Antilles",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Norway",
      "Oman",
      "Pakistan",
      "Palestine",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russia",
      "Rwanda",
      "Saint Pierre &amp; Miquelon",
      "Samoa",
      "San Marino",
      "Satellite",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "South Africa",
      "South Korea",
      "Spain",
      "Sri Lanka",
      "St Kitts &amp; Nevis",
      "St Lucia",
      "St Vincent",
      "St. Lucia",
      "Sudan",
      "Suriname",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      `Timor L'Este`,
      "Togo",
      "Tonga",
      "Trinidad &amp; Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks &amp; Caicos",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "United States",
      "Uruguay",
      "Uzbekistan",
      "Venezuela",
      "Vietnam",
      "Virgin Islands (US)",
      "Yemen",
      "Zambia",
      "Zimbabwe",
    ],
    colleges: [
      "Universitas Malikussaleh, Lhokseumawe",
      "Universitas Samudra, Langsa,",
      "Universitas Syiah Kuala, Banda Aceh",
      "Universitas Teuku Umar, Meulaboh",
      "Universitas Islam Negeri Ar-Raniry, Banda Aceh",
      "Universitas Sumatera Utara, Medan",
      "Universitas Negeri Medan, Medan",
      "Universitas Islam Negeri Sumatera Utara, Medan",
      "Universitas Andalas, Padang",
      "Universitas Negeri Padang, Padang",
      "Universitas Islam Negeri Imam Bonjol, Padang",
      "Universitas Riau, Pekanbaru",
      "Universitas Islam Negeri Sultan Syarif Kasim, Pekanbaru",
      "Universitas Maritim Raja Ali Haji, Tanjungpinang",
      "Universitas Jambi, Jambi",
      "Universitas Islam Negeri Sultan Thaha Saifuddin, Jambi",
      "Universitas Bengkulu, Bengkulu",
      "Universitas Sriwijaya, Palembang dan Indralaya",
      "Universitas Islam Negeri Raden Fatah, Palembang",
      "Universitas Lampung, Bandar Lampung",
      "Universitas Islam Negeri Raden Intan, Bandar Lampung",
      "Universitas Bangka Belitung, Kabupaten Bangka",
      "Universitas Sultan Ageng Tirtayasa, Serang dan Cilegon",
      "Universitas Terbuka, Tangerang Selatan",
      "Universitas Islam Negeri Sultan Maulana Hasanuddin, Serang",
      "Universitas Islam Negeri Syarif Hidayatullah Jakarta, Tangerang Selatan",
      "Universitas Indonesia, Jakarta Pusat dan Depok",
      "Universitas Negeri Jakarta, Jakarta Timur",
      "Universitas Veteran Jakarta, Jakarta Selatan dan Depok",
    ],
    editedIndex: -1,
    university: null,
    city: null,
    state: null,
    country: null,
    major: null,
    errorMessages: "",
    editedItem: {
      university: "",
      city: "",
      state: "",
      country: "",
      major: "",
    },
    defaultItem: {
      university: "",
      city: "",
      state: "",
      country: "",
      major: "",
    },
  }),

  computed: {
    form() {
      return {
        name: this.name,
        city: this.city,
        state: this.state,
        country: this.country,
        major: this.major,
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    name() {
      this.errorMessages = "";
    },
  },

  created() {
    this.headers = [
      {
        text: this.$t("page.profile.actions"),
        value: "actions",
        sortable: false,
        align: "center",
      },
      {
        text: this.$t("page.profile.univ_name"),
        align: "center",
        sortable: false,
        value: "university",
      },
      {
        text: this.$t("field.city"),
        value: "city",
        sortable: false,
        align: "center",
      },
      {
        text: this.$t("field.state"),
        value: "state",
        sortable: false,
        align: "center",
      },
      {
        text: this.$t("field.country"),
        value: "country",
        sortable: false,
        align: "center",
      },
      {
        text: this.$t("page.profile.major"),
        value: "major",
        sortable: false,
        align: "center",
      },
    ];
    this.initEducation();
  },

  methods: {
    async initEducation() {
      try {
        const res = await API.get(
          `${process.env.VUE_APP_API_TRUST}education/get`,
          {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Auth.getToken()}`,
          }
        );
        var tempData = [];
        for (const item in res.results) {
          let data = res.results[item];
          let format = {
            university: data.university,
            city: data.city,
            state: data.state,
            country: data.country,
            major: data.major,
          };
          tempData.push(format);
        }

        this.datas = tempData;
      } catch (error) {
        console.log(error);
      }
    },

    editItem(item) {
      this.editedIndex = this.datas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogEdit = true;
    },

    deleteItem(item) {
      this.editedIndex = this.datas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      let newData = JSON.parse(JSON.stringify(this.datas));
      newData.splice(this.editedIndex, 1);

      let loop_edukasi = [];
      for (var o in newData) {
        loop_edukasi.push(newData[o]);
      }

      let edukasi = {};
      edukasi["education"] = loop_edukasi;
      let formData = [];
      formData.push(edukasi);

      var _this = this;
      await API.put(
        `${process.env.VUE_APP_API_TRUST}education/update`,
        {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Auth.getToken()}`,
        },
        formData
      )
        .then(res => {
          if (res.statusCode == 201) {
            this.toast("success", this.$t("field.data_delete_success"));
            _this.initEducation();
            _this.closeDelete();
          } else if (res.statusCode == 400) {
            this.toast("error", res.message);
            // Object.keys(res.errors).forEach(element => {
            //   this.toast(
            //     "error",
            //     typeof res.errors[element] == "object"
            //       ? res.errors[element][0]
            //       : res.errors[element]
            //   );
            // });
          } else {
            this.$swal({
              icon: "error",
              text: res.message,
              //text: this.$t("error_try_again_latter"),
            });
          }
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            text: this.$t("error_try_again_latter"),
          });
        });
    },

    close() {
      this.errorMessages = [];
      this.formHasErrors = false;
      this.dialog = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeEdit() {
      this.errorMessages = [];
      this.formHasErrors = false;
      this.dialogEdit = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      /* eslint-disable no-unused-vars */
      if (this.$refs.form.validate() == true) {
        var form = {
          university: this.university,
          city: this.city,
          state: this.state,
          country: this.country.toUpperCase(),
          major: this.major,
        };
        this.initEducation();

        let newData = JSON.parse(JSON.stringify(this.datas));
        newData.push(form);

        let loop_edukasi = [];
        for (var o in newData) {
          loop_edukasi.push(newData[o]);
        }

        let edukasi = {};
        edukasi["education"] = loop_edukasi;
        let formData = [];
        formData.push(edukasi);

        var _this = this;
        await API.put(
          `${process.env.VUE_APP_API_TRUST}education/update`,
          {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Auth.getToken()}`,
          },
          formData
        )
          .then(res => {
            if (res.statusCode == 201) {
              this.toast("success", this.$t("field.data_add_success"));
              _this.initEducation();
              _this.close();
            } else if (res.statusCode == 400) {
              this.toast("error", res.message);
              // Object.keys(res.errors).forEach(element => {
              //   this.toast(
              //     "error",
              //     typeof res.errors[element] == "object"
              //       ? res.errors[element][0]
              //       : res.errors[element]
              //   );
              // });
            } else {
              this.$swal({
                icon: "error",
                text: res.message,
                //text: this.$t("error_try_again_latter"),
              });
            }
          })
          .catch(er => {
            this.$swal({
              icon: "error",
              text: this.$t("error_try_again_latter"),
            });
          });
      }
      // if (this.editedIndex > -1) {
      //   Object.assign(this.datas[this.editedIndex], this.editedItem);
      // } else {
      //   this.datas.push(this.editedItem);
      // }
      // this.close();
      /* eslint-disable no-unused-vars */
    },
    async update() {
      /* eslint-disable no-unused-vars */
      if (this.$refs.form.validate() == true) {
        let updatedData = Object.assign({}, this.datas);
        updatedData[this.editedIndex] = this.editedItem;

        let loop_edukasi = [];
        for (var o in updatedData) {
          loop_edukasi.push(updatedData[o]);
        }

        let edukasi = {};
        edukasi["education"] = loop_edukasi;
        let formData = [];
        formData.push(edukasi);

        var _this = this;
        await API.put(
          `${process.env.VUE_APP_API_TRUST}education/update`,
          {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Auth.getToken()}`,
          },
          formData
        )
          .then(res => {
            if (res.statusCode == 201) {
              this.toast("success", this.$t("field.data_edit_success"));
              _this.initEducation();
              _this.closeEdit();
            } else if (res.statusCode == 400) {
              this.toast("error", res.message);
              // Object.keys(res.errors).forEach(element => {
              //   this.toast(
              //     "error",
              //     typeof res.errors[element] == "object"
              //       ? res.errors[element][0]
              //       : res.errors[element]
              //   );
              // });
            } else {
              this.$swal({
                icon: "error",
                text: res.message,
                //text: this.$t("error_try_again_latter"),
              });
            }
          })
          .catch(er => {
            this.$swal({
              icon: "error",
              text: this.$t("error_try_again_latter"),
            });
          });
      }

      /* eslint-disable no-unused-vars */
    },
    toast(status, messages) {
      this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: toast => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        })
        .fire({
          icon: status,
          title: messages,
        });
    },
  },
};
</script>
<style>
.table-education thead {
  background: #ddd !important;
  font-weight: bold;
  color: #000 !important;
}
.table-education thead tr th {
  height: 38px !important;
}
.table-education tbody tr td {
  font-size: 12px !important;
  height: 35px !important;
}
.table-education tbody tr:hover {
  background-color: transparent !important;
}
</style>
<style lang="scss" scoped>
@import "@/assets/scss/color.scss";

.v-input__control {
  width: 700px;
}

.v-toolbar__title {
  font-size: 16px;
}

.a {
  color: #000;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 12px !important;
}
</style>
